module.exports = __webpack_public_path__ + "img/investor-foodxervices.bb9fb302.png";